module.exports = __webpack_public_path__ + "media/thanos_dust_2.7bd6a609.mp3";